import RatingPrompt from 'src/components/RatingPrompt.svelte';
import { home_data } from 'src/stores/account/user';
import { android_version, app, network, os } from 'src/stores/session/native-bridge';
import type { ModalConfig } from 'src/types/Modals';
import { get } from 'svelte/store';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';
import { compare } from 'compare-versions';
import { NativeOperationSystem } from 'src/services/init/types/init-type';

export const RatingPromptModalConfig = (forceShow = false): ModalConfig => {
	const homeData = get(home_data);
	const activeCampaign = setLastActiveCampaign(homeData);
	let shouldShowOldModal = true;
	let hasSeenLastActiveCampaign = true;

	if (get(os) !== NativeOperationSystem.IOS) {
		shouldShowOldModal = !compare(get(android_version), '1.35.0', '>=');
	}

	if (!activeCampaign?.android?.ts) {
		hasSeenLastActiveCampaign = false;
	}

	return {
		id: 'ratePromptState',
		component: RatingPrompt,
		props: {
			priority: 30, // Low priority
			showModal: shouldShowOldModal,
			campaignId: activeCampaign?.id,
		},
		rules: [
			{
				check: () =>
					forceShow ||
					(get(app) &&
						get(network) !== 'offline' &&
						activeCampaign &&
						!hasSeenLastActiveCampaign),
				expected: true,
			},
			NoPremiumVoucherCheckRule,
		],
	};
};

function setLastActiveCampaign(homeData) {
	const now = Math.floor(Date.now() / 1000);
	const platform = get(os);
	let lastActiveCampaign = null;

	if (!homeData?.ar_campaigns) {
		return lastActiveCampaign;
	}

	for (const campaign of homeData.ar_campaigns) {
		if (campaign.ts < now && !campaign[platform]?.seen_ts) {
			lastActiveCampaign = campaign;
			break;
		}
	}

	return lastActiveCampaign;
}
